import { fontSizes, fontWeights, lineHeight, margins } from '@ohgoodlord/design-system'
import styled from 'styled-components'
import { colors } from '../../../../src/common/colors'

export const PageWrapper = styled.div`
  position: relative;
  height: 100vh;
  width: 100vw;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  overflow-y: auto;
  padding-bottom: 140px;
  background-color: #f9f9f9;
`

export const StickyHeader = styled.div<{ $isExpanded: boolean }>`
  position: fixed;
  z-index: 99999;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 65px;
  top: 0;
  width: 100%;
  top: ${props => (props.$isExpanded ? '0' : '-65px')};
  background: ${colors.navyBlue};
  transition: top 0.35s;
`

export const TitleWrapper = styled.div`
  display: flex;
  width: 100%;
  margin-top: 100px;
  margin-bottom: ${margins.l};
  align-items: center;
  flex-direction: column;
  gap: ${margins.s};
`

export const LandingPageTitle = styled.h1`
  margin: 0;
  font-size: ${fontSizes.l};
  font-weight: ${fontWeights.bold};
  line-height: ${lineHeight};
  letter-spacing: -0.01em;
  text-align: center;
  color: ${colors.botChatPrimary};
`

export const LandingPageDescription = styled.div`
  font-size: ${fontSizes.m};
  font-weight: ${fontWeights.normal};
  line-height: ${lineHeight};
  text-align: center;
  color: ${colors.greyscale2};
  padding: 0 12px;
  max-width: 640px;
`
